import ConfigApiRequest from '@/api/config'
import { StatusCodeType } from '@/enum'
import { defineStore } from 'pinia'
import getters from './getters'
import state from './state'

const usConfigStore = defineStore('config', {
  state: () => state,
  getters,
  actions: {
    async getUnitConfiguration() {
      const configApiRequest = new ConfigApiRequest()
      const response = await configApiRequest.getUnits()
      if (response.status === StatusCodeType.Success) {
        this.unitsConfig = response.data
      }
    }
  }
})
export default usConfigStore
